<template>
  <div class="popover-langs">
    <el-input
      v-model="replayTranslateTitle"
      :placeholder="$t('common.Input-Language-Name')"
      size="mini"
      style="width: 100%"
      @input="replayTranslate"
    ></el-input>
    <div class="list">
      <div
        class="list-item"
        v-for="(name, code) in filterLangs"
        :key="code"
        @click="
          langClick({
            name,
            code,
          })
        "
      >
        {{ displayLanguageName(code, name) }}
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
    translatePopperVisible: Boolean,
    // WhatsApp 工作台按界面语言显示语种；其他使用方仍沿用接口名称。
    localizeNames: { type: Boolean, default: false },
  },
  data() {
    return {
      replayTranslateTitle: "",
      convertLanguage: {},
      filterLangs: {},
    };
  },
  watch: {
    translatePopperVisible(value) {
      if (!value) {
        this.replayTranslateTitle = "";
      }
    },
    // 语种目录可能在弹层创建后才到达，切换界面语言时也要重新匹配搜索结果。
    tool_languages() {
      this.getToolLanguages();
    },
    "$i18n.locale"() {
      if (this.localizeNames) this.replayTranslate();
    },
  },
  computed: {
    ...mapGetters("globalState", ["tool_languages"]),
  },
  created() {
    this.getToolLanguages();
  },
  methods: {
    displayLanguageName(code, rawName) {
      if (!this.localizeNames) return rawName;
      const locale = String(this.$i18n.locale || "zh-CN").toLowerCase().startsWith("en") ? "en" : "zh-CN";
      try {
        const label = new Intl.DisplayNames([locale], { type: "language" }).of(String(code).replace(/_/g, "-"));
        if (label && label !== code) return label;
      } catch (_) {
        // 非标准语种代码仍可使用同语言名称，避免弹层显示另一种界面语言。
      }
      const text = String(rawName || "");
      const matchesLocale = locale === "en" ? !/[\u3400-\u9fff]/u.test(text) : /[\u3400-\u9fff]/u.test(text);
      return matchesLocale ? text : this.$t("whatsapp-service.TranslationLabel");
    },
    getToolLanguages() {
      this.convertLanguage = { ...this.tool_languages };
      this.replayTranslate();
    },
    langClick(lang) {
      this.$emit("langClick", lang);
    },
    replayTranslate() {
      const obj = {};
      for (const key in this.convertLanguage) {
        const lang = this.convertLanguage[key];
        // 搜索同时接受接口名称和当前界面语言名称，选择时仍回传原始名称及代码。
        const displayName = this.displayLanguageName(key, lang);
        if (`${lang} ${displayName}`.toLocaleLowerCase().includes(this.replayTranslateTitle.toLocaleLowerCase())) {
          obj[key] = lang;
        }
      }
      this.filterLangs = { ...obj };
      this.$emit("updatePop");
    },
  },
  beforeUnmount() {
    this.replayTranslateTitle = "";
  },
};
</script>
<style scoped lang="scss">
.popover-langs {
  .list {
    max-height: 200px;
    overflow-y: auto;
    padding-top: 10px;
    .list-item {
      padding: 5px 10px;
      font-size: 12px;
      cursor: pointer;
      &:hover {
        background: #f5f5f5;
      }
    }
  }
}
</style>
